import {
  DAY_KEY,
  getByIdDaysSelector,
  getValueReduxUtil,
  WORKOUT_KEY
} from '@gymaholic/packages'
import Text from 'components/Text'
import TextTitleCondensed from 'components/TextTitleCondensed'
import { View } from 'components/View'
import React from 'react'
import Link from 'components/Link'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { logUtil } from 'packages/src'
import { getByIdWorkoutSelector } from 'modules/workout/redux/selectors'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import WorkoutMediaImage from 'containers/WorkoutMediaImage'
import { Image } from 'components/Image'
import { defineMessages } from 'react-intl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import RestImage from 'components/RestImage/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl'
import getPlanWorkoutPathnameUtil from 'modules/workout/redux/utils/get-plan-workout-pathname/index.js'
import { PlanDayRowPlannedAt } from 'modules/plan/components/PlanDay/components/PlannedAt/index.js'
import { isCompletedByIdDaySelector } from 'modules/day/redux/selectors/isCompletedById/index.js'
import { isTodayByIdDaySelector } from 'modules/day/redux/selectors/isTodayById/index.js'

// TODO move to package
const getWorkoutsByDayIdDaySelector = (id) => state => {
  const day = getByIdDaysSelector(id)(state)
  const workoutPointers = getValueReduxUtil(day, DAY_KEY.WORKOUTS) || []
  return workoutPointers.map(workoutPointer => {
    return getByIdWorkoutSelector(getIdReduxUtil(workoutPointer))(state)
  })
}

const messages = defineMessages({
  restDay: {
    id: 'PlanDay.restDay',
    defaultMessage: 'Rest day'
  }
})

/**
 * @param id
 * @param index
 * @param isClickable
 * @param cantEdit
 * @param hasStarted
 * @param plan - The plan instance
 * @returns {Element}
 * @constructor
 */
export function PlanDay ({
  id,
  index,
  isClickable,
  cantEdit,
  hasStarted,
  plan
}) {
  const day = useSelector(getByIdDaysSelector(id))
  const workouts = useSelector(getWorkoutsByDayIdDaySelector(id))
  const workout = workouts[0]
  const isRest = !workout
  const url = workout && plan
    ? getPlanWorkoutPathnameUtil({ workout, plan })
    : null
  const workoutId = getIdReduxUtil(workout)
  const intl = useIntl()
  const debugProps = {
    id,
    day,
    workoutId,
    workouts,
    workout
  }
  logUtil('PlanDay').debug('debugProps=', debugProps)

  const imageStyle = {
    borderTopLeftRadius: '6px',
    borderBottomLeftRadius: '6px',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }

  const Element = url ? Link : View
  const name = (
    getValueReduxUtil(workout, WORKOUT_KEY.NAME) ||
    formatMessageIntlUtil(intl, messages.restDay)
  )

  const plannedAtStr = getValueReduxUtil(day, DAY_KEY.PLANNED_AT)
  const isCompleted = useSelector(isCompletedByIdDaySelector(id))
  const isToday = useSelector(isTodayByIdDaySelector(id))

  isClickable = isClickable && !isCompleted

  const restStyle = {
    ...imageStyle,
    height: '100%',
    objectFit: 'cover'
  }

  const style = {
    opacity: isCompleted ? 0.5 : 1,
    paddingBottom: '1.125em',
    paddingTop: '1.5em',
    pointerEvents: isClickable ? 'unset' : 'none'
  }

  let contentBgc
  if (hasStarted && isToday && !isCompleted) {
    contentBgc = '#F0F4F5'
  } else if (cantEdit) {
    contentBgc = 'transparent'
  } else {
    contentBgc = '#FFFFFF'
  }

  return (
    <Element
      to={url}
      style={style}
    >
      <View
        key={index}
        bgc={contentBgc}
        row
        ac
        style={{
          border: cantEdit
            ? '1px solid #DDDDDD'
            : 'unset',
          borderRadius: '6px'
        }}
      >
        <View
          style={{
            width: '80px',
            minWidth: '80px',
            height: '100px',
            overflow: 'hidden',
            ...imageStyle
          }}
        >
          {
            isRest
              ? <RestImage style={restStyle} />
              : (
                <WorkoutMediaImage
                  id={workoutId}
                  aspectRatio={Image.ASPECT_RATIO.TALL}
                  style={imageStyle}
                />
                )
          }
        </View>
        <View
          w='75%'
          jc
          px='16px'
          style={{
            position: 'relative',
            boxSizing: 'border-box'
          }}
        >
          <View row>
            <Text
              fs='11px'
              c='#7F8D94'
              fw='590'
              style={{
                whiteSpace: 'nowrap',
                textTransform: 'uppercase'
              }}
            >Day {getValueReduxUtil(day, DAY_KEY.ORDER)}
            </Text>

            {
              hasStarted &&
              !!plannedAtStr && (
                <PlanDayRowPlannedAt id={id} />
              )
            }
          </View>
          <TextTitleCondensed
            c='#151D21'
            fw='760'
            fs='18px'
            mt='4px'
          >
            {name}
          </TextTitleCondensed>
        </View>
      </View>
    </Element>
  )
}
